import React from 'react';
import TopProposal from '../Proposal/TopProposal';
import MovimentsTableRow from './MovimentsTableRow';
import { displayDate } from '@iso/lib/helpers/utility';
import MovimentsTableHeader from './MovimentsTableHeader';
import MovimentsTableFooter from './MovimentsTableFooter';
import { Page, Document, StyleSheet, Text, View } from '@react-pdf/renderer';

let employeLogoDimensions = [170,65];
let image = sessionStorage.getItem('employeLogo');

if(image !== null && typeof image !== 'undefined')
    employeLogoDimensions = sessionStorage.getItem('employeLogoDimensions').split('x');

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 9,
        paddingTop: 30,
        paddingLeft:30,
        paddingRight:30,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
      marginLeft: '0',
      width: employeLogoDimensions[0], 
      height: employeLogoDimensions[1],
        // marginRight: 'auto'
    },
    pageTitleContainer: {
        flexDirection: 'row',
        marginTop: 5,
        width: '100%',
        justifyContent: 'center'
    },
    pageTitle:{
        fontSize: 10,
        fontWeight: 'bold',
        fontFamily: 'Helvetica-Bold',
    },
    reportTitle:{
        fontSize: 9,
        marginTop: 5,
        textIndent:'5px',
        fontFamily: 'Helvetica-Bold'
    },
    fragmentContainer: {
        width: '100%',
        padding:'2px',
        borderRadius:'3px',
        flexDirection: 'row',
        border: '1px solid #000000'
    }
});

const FinanceMoviment = ({data}) => {

    let hasFilters = false;
    
    if(typeof data.filters !== 'undefined' && data.filters.length > 0)
        hasFilters = true;

    return (
        <Document debug={true}>
            <Page size="A4" style={styles.page} orientation={'landscape'} wrap={true}>

                <View render={({ pageNumber, totalPages }) => (
                    <View style={{width:'100%', flexDirection: 'row', marginBottom:'10px'}}>
                        <Text style={{width:'33%', fontSize:8}}>{displayDate()}</Text>
                        <Text style={{width:'33%', fontSize:8, textAlign:'center'}}>{`Página ${pageNumber} / ${totalPages}`}</Text>
                        <Text style={{width:'34%', fontSize:8, textAlign:'right'}}>{data.title}</Text>
                    </View>
                )} fixed/>

                <TopProposal invoice={data.empresa} />

                <View style={styles.pageTitleContainer}>
                    <Text style={styles.pageTitle}>{`Movimentação financeira ${data.moviment_dates}`}</Text>
                </View>

                { hasFilters ? 
                    <>
                        <Text style={styles.reportTitle}>Filtros:</Text>
                        <View key={"container"} style={styles.fragmentContainer}>
                            <Text key={'address'} style={styles.label}>{data.filters}</Text>
                        </View>
                    </>
                : <></>}
                {
                    data.payments.length > 0 ?
                    <>
                        <View style={styles.tableContainer}>
                            <MovimentsTableHeader />
                            <MovimentsTableRow items={data.payments}/>
                            <MovimentsTableFooter items={data.payments} />
                        </View>
                    </>
                    :
                    <View key={"container"} style={styles.fragmentContainer}>
                        <Text key={'address'} style={styles.label}>Sem registros...</Text>
                    </View>
                }
            </Page>
        </Document>
    )
};
  
export default FinanceMoviment